// extracted by css-extract-rspack-plugin
export default {"cls1":"Autocomplete-cls1_BrX","cls2":"Autocomplete-cls2_Lvi Autocomplete-cls1_BrX"};